import { render } from "./ZebRegister.vue?vue&type=template&id=0ae4c38a&scoped=true"
import script from "./ZebRegister.vue?vue&type=script&lang=js"
export * from "./ZebRegister.vue?vue&type=script&lang=js"

import "./ZebRegister.vue?vue&type=style&index=0&id=0ae4c38a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae4c38a"]])

export default __exports__